// Keyless Google Maps embed. No API key required.
export const MapEmbed = ({ title, query = "Molesey, Surrey, UK", zoom = 12, className = "" }) => (
  <div data-testid="map-embed" className={`overflow-hidden rounded-card border border-line bg-alt ${className}`}>
    <iframe
      title={title}
      data-testid="map-embed-iframe"
      src={`https://www.google.com/maps?q=${encodeURIComponent(query)}&z=${zoom}&output=embed`}
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
      className="h-full w-full"
      style={{ border: 0, display: "block", minHeight: "320px" }}
    />
  </div>
);
